import { type TranslationTree } from '@/i18n/types';

export const messages = {
  fileTooLarge: 'A imagem deve ter no máximo 5 MB.',
} satisfies TranslationTree;
